/**
 * Created with JetBrains PhpStorm.
 * User: MQuill
 * Date: 9/25/15
 * Time: 3:14 PM
 * To change this template use File | Settings | File Templates.
 */


scgwShopify = [];
var $easyzoom;

scgwShopify.idDonation = 5056233603; //Varient ID
$(document).ready( function(){
    scgwMenuFormat();

    jQuery('.jqzoom').jqzoom({
        zoomType: 'innerzoom',
        preloadImages: false,
        alwaysOn:false,
        title: false
    });
})

window.onresize = function( event ){
    scgwMenuFormat();
}

function  scgwMenuFormat(){
    console.clear();

    var navTextWidth = 0;
    var navTextCount = 0;
    var navWidth = $('.site-nav').width();
    var padding = 0;


    $('.site-nav>li').each(function(){
        navTextWidth += parseInt( $( this ).width(),10);
        navTextCount++;
        console.log( navTextWidth) ;
    });

    padding = (navWidth - navTextWidth) / (( navTextCount-1) * 2);
    padding = parseInt(padding,10)-3;//  + 'px';

    var loop = 0
    var currentPadding = 0;

    $('.site-nav>li').each(function(){

        if( loop > 0 ) {
            currentPadding = parseInt( $( this ).css('margin-left'),10);
            currentPadding = currentPadding + padding
            $( this ).css('margin-left', currentPadding + 'px');

        } else {
            $( this ).css('margin-left', '0');
        }

        if( loop < navTextCount-1 ){
            currentPadding = parseInt( $( this ).css('margin-right'),10);
            currentPadding = currentPadding + padding
            $( this ).css('margin-right', currentPadding + 'px');
        } else {
            $( this ).css('margin-right', '0');
        }
       loop++;
    })
}


function scgwAddDonation( doPageRefresh ){

    if( doPageRefresh == undefined ){
        doPageRefresh = true;
    }
    console.log('Adding Donation');

    var request = $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: 1, id: scgwShopify.idDonation } })
        .always(function() {
            alert('Donation Added');
            if( doPageRefresh){
                location.reload();
            }
        });
}
window.onresize = function( event ){
    scgwMenuFormat();
}


function scgwAjaxAddDonation(){
    scgwAddDonation( false );
}


function swapThumbnail( thumbnail ){

    $('#ProductPhotoImgZoom').removeData( 'jqzoom');
    $('#ProductPhotoImg').attr('src', thumbnail.dataset.medium );
    $('#ProductPhotoImgZoom').attr('href', thumbnail.dataset.full );
    $('.jqzoom').jqzoom();

}




